var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconIllustrationPlaneFlying(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 80 80",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M63 45H50v-2h13c2.921 0 5.936-1.815 7-2.523v-.954C68.936 38.815 65.921 37 63 37H20a.996.996 0 01-.707-.293L14.586 32h-1.329l2.539 11H27v2H15a1 1 0 01-.975-.775l-3-13A1 1 0 0112 30h3c.266 0 .52.105.707.293L20.414 35H63c4.284 0 8.426 3.069 8.6 3.2a1 1 0 01.4.8v2a1 1 0 01-.4.8c-.174.131-4.316 3.2-8.6 3.2",
    fill: "#E97025",
    className: "fi-icon-illustrative-highlight-fill"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.414 35h11.727l-14.4-8h-5.327l8 8zM51 37H35a.996.996 0 01-.707-.293l-10-10A1 1 0 0125 25h8a.99.99 0 01.485.126l18 10A1 1 0 0151 37zM27.414 49h5.327l14.4-8H35.414l-8 8zM33 51h-8a1 1 0 01-.707-1.707l10-10A.996.996 0 0135 39h16a1 1 0 01.485 1.874l-18 10A.99.99 0 0133 51z",
    fill: "#E97025",
    className: "fi-icon-illustrative-highlight-fill"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A5ADB1",
    d: "M58 41h2v-2h-2zM54 41h2v-2h-2zM28 41h2v-2h-2zM24 41h2v-2h-2zM20 41h2v-2h-2zM14 51h8v-2h-8zM8 51h4v-2H8zM18 27h4v-2h-4zM8 27h8v-2H8zM65 31h-2v-1c0-4.411-3.589-8-8-8h-3.002l1.202-1.601c.524-.696.8-1.525.8-2.399 0-2.206-1.794-4-4-4a3.96 3.96 0 00-2.399.799l-.78.587-.605-.766C43.791 11.555 40.69 10 37 10c-6.065 0-11 4.935-11 11h-2c0-7.168 5.832-13 13-13 3.983 0 7.494 1.617 10.206 4.688a6.006 6.006 0 018.446 7.333C60.863 20.358 65 24.705 65 30v1M40.94 56.339l-1.88-.678C39.78 53.658 42.29 49 50 49c4.063 0 7.868 1.599 10.713 4.501l-1.428 1.4A12.904 12.904 0 0050 51c-6.21 0-8.341 3.345-9.06 5.339M27 68h-2c0-5.514 4.486-10 10-10 2.465 0 4.833.905 6.669 2.548l-1.334 1.49A7.989 7.989 0 0035 60c-4.411 0-8 3.589-8 8",
    className: "fi-icon-illustrative-base-fill"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64 68v-2c3.309 0 6-2.691 6-6s-2.691-6-6-6-6 2.691-6 6h-2c0-4.411 3.589-8 8-8s8 3.589 8 8-3.589 8-8 8",
    fill: "#A5ADB1",
    className: "fi-icon-illustrative-base-fill"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A5ADB1",
    d: "M50 68h14v-2H50zM44 68h4v-2h-4zM14 72h4v-2h-4z",
    className: "fi-icon-illustrative-base-fill"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 72c-3.309 0-6-2.691-6-6a6.008 6.008 0 015.297-5.959C14.653 56.914 17.921 55 22 55c4.432 0 8 3.282 8 6h-2c0-1.405-2.475-4-6-4-3.462 0-6.164 1.654-7.052 4.316l-.227.684H14c-2.206 0-4 1.794-4 4s1.794 4 4 4v2",
    fill: "#A5ADB1",
    className: "fi-icon-illustrative-base-fill"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h80v80H0z"
  }))));
}

export default SvgIconIllustrationPlaneFlying;